var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.c_tag,_vm._b({tag:"Component",staticClass:"link",class:[
    ("link-" + _vm.color),
    {
      'active': _vm.active,
      'bold': _vm.bold,
      'size-small': _vm.size === 'small',
      'size-big': _vm.size === 'big',
    } ],attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){return _vm.$emit('click', $event)}}},'Component',_vm.c_link,false),[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }